import { Nullable } from '../../interfaces';
import { createAsyncAtom } from '../../lib';

const evmWalletAddressAtom = createAsyncAtom<Nullable<string>>(async () => null);

export default evmWalletAddressAtom;
